import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import BalanceCardSM from "../dashboard/components/BalanceCardSM.jsx";
import { GetWalletApi } from "../../../api/request/wallet/withdraw.js";
import { GetPaymentGatewayApi } from "../../../api/request/wallet/deposit.js";
import toast from "react-hot-toast";
import DepositMobile from "./deposit/DepositMobile.jsx";
import { WalletOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import WithdrawMobile from "./withdraw/WithdrawMobile.jsx";

export default function WalletPage() {
  const { userDetails } = useSelector((state) => state?.user);
  const location = useLocation();
  const getInitialTab = () => {
    if (location.pathname.includes("withdraw")) return "Withdraw";
    return "Deposit";
  };
  const [selectedTab, setSelectedTab] = useState(getInitialTab);
  const [walletDetails, setWalletDetails] = useState(null);
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const getPaymentGateway = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetPaymentGatewayApi();
      if (data?.success) setPaymentGateways(data?.data);
    } catch (error) {
      if (error?.response?.data?.error?.message)
        toast.error(error?.response?.data?.error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getWalletDetails = async () => {
    setIsLoading(true);
    try {
      const params = { RuleType: "Withdraw" };
      const { data } = await GetWalletApi(userDetails?.id, params);
      if (data?.success) setWalletDetails(data?.data);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setSelectedTab(getInitialTab());
  }, [location.pathname]);

  useEffect(() => {
    getPaymentGateway();
    getWalletDetails();
  }, []);
  
  const balanceCardsData = [
    {
      id: 1,
      type: "Wallet No.",
      amount: walletDetails?.walletAccountNo || 0.0,
      color: "bg-[#9810FA]",
      gradient: "from-[#FAF5FF] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      id: 2,
      type: "Wallet Balance",
      amount: walletDetails?.walletAmount || 0.0,
      color: "bg-green-500",
      gradient: "from-[#F0FDF4] to-[#ffff]",
      icon: (
        <PlusCircleOutlined size={20} color="#fff" className="text-white" />
      ),
    },
    {
      id: 3,
      // type: "Min Deposit",
      type :  selectedTab === "Withdraw"
          ? "Min Withdraw"
          : "Min Deposit",
      amount:
        selectedTab === "Withdraw"
          ? walletDetails?.minAmount || 0.0
          : paymentMethod?.minAmount || 0.0,
      color: "bg-orange-500",
      gradient: "from-[#FFF7ED] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
    {
      id: 4,
       type :  selectedTab === "Withdraw"
          ? "Max Withdraw"
          : "Max Deposit",
      amount:
        selectedTab === "Withdraw"
          ? walletDetails?.maxAmount || 0.0    
          : paymentMethod?.maxAmount || 0.0,
      color: "bg-red-500",
      gradient: "from-[#FFEDED] to-[#ffff]",
      icon: <WalletOutlined size={20} color="#fff" className="text-white" />,
    },
  ];

  return (
    <div className="mobile-dashboard min-h-screen">
      {/* Deposit/Withdraw Toggle */}
      <div className="mb-6 bg-white rounded-lg shadow-sm py-2 px-3">
        <Tabs
          activeKey={selectedTab}
          onChange={setSelectedTab}
          centered
          size="large"
          items={["Deposit", "Withdraw"]?.map((type) => ({
            key: type,
            label: type,
          }))}
          className="custom-tabs mobile-account-tabs"
        />
      </div>

      <div className="grid grid-cols-2 gap-3 my-6">
        {balanceCardsData.map((card, index) => (
          <BalanceCardSM
            key={card.id || index}
            type={card.type}
            amount={card.amount}
            color={card.color}
            gradient={card.gradient}
            icon={card.icon}
            className="text-center px-2 pb-1 py-2"
            innerClassName="flex-col gap-2 !mb-0"
            titleClass="!text-[8px] !leading-none !ml-0"
            amountClass="!text-[10px]"
          />
        ))}
      </div>

      {selectedTab === "Deposit" && <DepositMobile setPaymentMethods={setPaymentMethod}/> }
      {selectedTab === "Withdraw" && <WithdrawMobile setPaymentMethods={setPaymentMethod} />}
    </div>
  );
}
